import classes from "../homePageNew.module.css";
import MonitoringSelectField from "./MonitoringSelectField";
import MonitoringLlmMultiSelect from "./MonitoringLlmMultiSelect";

const RUN_TYPE_OPTIONS = [
  { id: "brand", name: "Brand" },
  { id: "product", name: "Product" },
];

/**
 * The COMBINATION card — Type / Brand-or-Product / Category / Market /
 * Persona / Geography, then the LLM multiselect. Purely presentational:
 * MonitoringModule.js owns all selection state and the cascading-narrowing
 * logic, this just renders whatever options/values it's handed.
 */
export default function MonitoringSelectorBar({
  runType,
  onRunTypeChange,
  hasProducts,
  entityOptions,
  selectedEntityId,
  onEntityChange,
  dimensionOptions,
  dims,
  onDimChange,
  providerLlms,
  selectedProviders,
  onProvidersChange,
}) {
  const selectedEntity = entityOptions.find((e) => e.id === selectedEntityId);

  return (
    <div className={classes.monFilterCard}>
      <div className={classes.monFilterCardTitle}>COMBINATION</div>
      <div className={classes.comboBar}>
        <MonitoringSelectField
          label="Type"
          value={runType}
          valueLabel={runType === "product" ? "Product" : "Brand"}
          options={RUN_TYPE_OPTIONS}
          onChange={onRunTypeChange}
          disabled={!hasProducts}
        />
        <MonitoringSelectField
          label={runType === "product" ? "Product" : "Brand"}
          value={selectedEntityId}
          valueLabel={selectedEntity?.name}
          options={entityOptions}
          onChange={onEntityChange}
        />
        <MonitoringSelectField
          label="Category"
          value={dims.categoryId}
          valueLabel={dimensionOptions.category.find((o) => o.id === dims.categoryId)?.name}
          options={dimensionOptions.category}
          onChange={(id) => onDimChange("category", id)}
        />
        <MonitoringSelectField
          label="Market"
          value={dims.marketId}
          valueLabel={dimensionOptions.market.find((o) => o.id === dims.marketId)?.name}
          options={dimensionOptions.market}
          onChange={(id) => onDimChange("market", id)}
        />
        <MonitoringSelectField
          label="Persona"
          value={dims.personaId}
          valueLabel={dimensionOptions.persona.find((o) => o.id === dims.personaId)?.name}
          options={dimensionOptions.persona}
          onChange={(id) => onDimChange("persona", id)}
        />
        <MonitoringSelectField
          label="Geography"
          value={dims.geographyId}
          valueLabel={dimensionOptions.geography.find((o) => o.id === dims.geographyId)?.name}
          options={dimensionOptions.geography}
          onChange={(id) => onDimChange("geography", id)}
        />
        {providerLlms.length > 0 && (
          <MonitoringLlmMultiSelect providerLlms={providerLlms} selectedProviders={selectedProviders} onChange={onProvidersChange} />
        )}
      </div>
    </div>
  );
}
